import { render, staticRenderFns } from "./ElepyFile.vue?vue&type=template&id=1efd164a&"
import script from "./ElepyFile.vue?vue&type=script&lang=js&"
export * from "./ElepyFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports